import { AnimatePresence } from "framer-motion";
import { useState } from "react";
import styled from "styled-components";

import Text from "@/components/Text";
import ScriptCreationModal from "./ScriptCreationModal";

const Box = styled.div`
  padding: 16px;
  background-color: ${({ theme }) => theme.colors.white};
  display: flex;
  gap: 16px;
`;

const Button = styled.button`
  border: 1px solid ${({ theme }) => theme.colors.grayscale};
  border-radius: 4px;
  flex: 1;
  height: 120px;
  color: ${({ theme }) => theme.colors.gray};
  transition: all ease-out 0.2s;
  ${Text} {
    color: ${({ theme }) => theme.colors.gray};
    transition: color ease-out 0.2s;
  }
  svg {
    margin-bottom: 8px;
  }
  &:not([disabled]) {
    &:hover,
    &:active {
      color: ${({ theme }) => theme.colors.purple};
      border-color: ${({ theme }) => theme.colors.purple};
      ${Text} {
        color: ${({ theme }) => theme.colors.black};
      }
    }
  }

  &:disabled {
    cursor: not-allowed;
  }
`;

const ScriptCreationButtons = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <Box>
      <Button onClick={() => setShowModal(true)}>
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 26.9998H6C5.73478 26.9998 5.48043 26.8945 5.29289 26.707C5.10536 26.5194 5 26.2651 5 25.9998V20.4141C5 20.2827 5.02587 20.1527 5.07612 20.0314C5.12638 19.9101 5.20004 19.7998 5.29289 19.707L20.2929 4.70695C20.4804 4.51942 20.7348 4.41406 21 4.41406C21.2652 4.41406 21.5196 4.51942 21.7071 4.70695L27.2929 10.2927C27.4804 10.4803 27.5858 10.7346 27.5858 10.9998C27.5858 11.2651 27.4804 11.5194 27.2929 11.707L12 26.9998Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17 8L24 15"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M26.9999 26.9999H11.9999L5.06348 20.0635"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <Text $type="smallBold">Blank page</Text>
      </Button>
      <Button disabled>
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M25 28H6.99902C6.73381 28 6.47945 27.8946 6.29192 27.7071C6.10438 27.5196 5.99902 27.2652 5.99902 27V5C5.99902 4.73478 6.10438 4.48043 6.29192 4.29289C6.47945 4.10536 6.73381 4 6.99902 4H19L26 11V27C26 27.1313 25.9741 27.2614 25.9239 27.3827C25.8736 27.504 25.8 27.6143 25.7071 27.7071C25.6143 27.8 25.504 27.8736 25.3827 27.9239C25.2614 27.9741 25.1313 28 25 28Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19 4V11H26.001"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 17H20"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 21H20"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <Text $type="smallBold">Template</Text>
      </Button>
      <AnimatePresence>
        {showModal && (
          <ScriptCreationModal onClose={() => setShowModal(false)} />
        )}
      </AnimatePresence>
    </Box>
  );
};

export default ScriptCreationButtons;
